<template>
<div id="new">
    <div class="title" style="font-size:22px;">
        {{ newMsg.data.title }}
    </div>
    <section v-html="newMsg.data.answer_text" class="flex-c new-content">
        <!-- 新闻文本 -->
    </section>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex';
export default {
    data() {
        return {

        }
    },
    computed: {
        ...mapGetters([
            'newMsg'
        ])
    },
    created() {
        let newId = this.$route.query.newId;
        this.$store.dispatch('changeNewId', {
            id: newId
        });
        this.$store.dispatch('getNewApi');
    },
    methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" >
#new{
    margin: 0 auto;
    max-width: 800PX;
    .title{
        font-size: 27px;
        text-align: center;
        padding-top: 20px;
        word-wrap: break-word;
    }
    .new-content{
        font-size: 24px;
        padding: 20px;
        word-wrap: break-word;
        overflow: hidden;
        img{
            max-width: 100%;
        }
    }
}
</style>
